module.exports = __webpack_public_path__ + "img/niels.1cdca9ba.jpeg";